function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000001;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M65.14,64.25a.73.73,0,0,1-.73.73H60.8a.72.72,0,0,1-.72-.73V57.64c0-1,.29-4.32-2.58-4.32-2.22,0-2.67,2.29-2.76,3.31v7.62A.73.73,0,0,1,54,65H50.52a.72.72,0,0,1-.72-.73V50a.72.72,0,0,1,.72-.73H54a.73.73,0,0,1,.73.73v1.22c.82-1.23,2-2.19,4.66-2.19,5.77,0,5.74,5.4,5.74,8.36ZM45.1,48a3.2,3.2,0,1,1,3.19-3.19A3.19,3.19,0,0,1,45.1,48Zm2.47,16.21a.79.79,0,0,1-.79.79H43.42a.79.79,0,0,1-.79-.79V50.1a.79.79,0,0,1,.79-.79h3.36a.79.79,0,0,1,.79.79Zm18-25.9H41A2.71,2.71,0,0,0,38.29,41V65.57A2.71,2.71,0,0,0,41,68.29H65.57a2.72,2.72,0,0,0,2.72-2.72V41A2.71,2.71,0,0,0,65.57,38.29Z",
  transform: "translate(-38.29 -38.29)"
});

function SvgSocialButtonLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialButtonLinkedin);
export default __webpack_public_path__ + "static/media/Social_Button_Linkedin.e8773da6.svg";
export { ForwardRef as ReactComponent };